import { genres } from '@/mocks/comicData';

export default function GenreGrid() {
  return (
    <section id="category" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
              <i className="ri-grid-fill"></i>题材分类大全
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              按题材，一找一个准
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600 md:text-base">
              国漫日漫全按题材类型整理，热门连载、经典全本都有归属。
              想看热血还是恋爱，点进对应分类即可直达。
            </p>
          </div>
          <a
            href="#hot"
            className="whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            去热门连载看看 <i className="ri-arrow-right-line align-middle"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {genres.map((g) => (
            <a
              key={g.id}
              href="#hot"
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-transform duration-300 hover:-translate-y-1 md:p-5"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br ${g.color} text-xl text-background-50`}
              >
                <i className={g.icon}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-base font-bold text-foreground-950">{g.name}</h3>
                  <span className="whitespace-nowrap text-xs font-medium text-secondary-700">
                    {g.count}
                  </span>
                </div>
                <p className="mt-1 text-xs leading-5 text-foreground-600 md:text-[13px]">{g.desc}</p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                  进入分类 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}